import { connect } from 'react-redux';
import {
  droppingAnimationStart,
} from '../../../redux/actions/Orders';

const mapStateToProps = state => ({
  location: state.mainreducer.area,
  selectedLocations: state.mainreducer.selectedLocations,
});

const mapDispatchToProps = dispatch => ({
  droppingAnimationStart(location) {
    dispatch(droppingAnimationStart(location));
  },
});

export default DetailsLeftPart => connect(mapStateToProps, mapDispatchToProps)(DetailsLeftPart);
